exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".partsRequisitionView[data-v-e3b6b902] .partsOrderLinesTable{line-height:1}.partsRequisitionView[data-v-e3b6b902] .partsOrderLinesTable th{vertical-align:middle}\n", ""]);

